<p-tree
  *ngIf="globalsStore.isTreeInitialized"
  class="w-full md:w-30rem"
  filterPlaceholder="durchsuchen ..."
  [filter]="!!categoryTree.length"
  [lazy]="true"
  [(selection)]="selectedNode"
  (onNodeDrop)="nodeDropped($event)"
  [contextMenu]="cm"
  [value]="categoryTree"
  [draggableNodes]="true"
  [droppableNodes]="true"
  [validateDrop]="true"
  [trackBy]="trackByNodeId"
  (onNodeContextMenuSelect)="getMenuItemsByType($event)">
  <ng-template pTemplate="category" let-node>
    <div
      (click)="toggleExpand(node)"
      class="cursor-pointer flex align-items-center gap-2 relative"
      pTooltip="Rechtsklick für weitere Optionen."
      [showDelay]="600">
      <i
        class="tree-category-icon"
        [ngClass]="
          !node.expanded && node.children.length
            ? 'fas fa-folder'
            : node.expanded && node.children.length
              ? 'fas fa-folder-open'
              : 'fa-regular fa-folder'
        "></i>
      <i
        *ngIf="node.locked"
        class="lock-overlay-icon lock-overlay-icon--category fas fa-lock"></i>
      <span
        *ngIf="
          node.number &&
          globalsStore.activeCommune()?.atlasConfig?.showIndicatorNumbers !==
            false
        "
        class="folder-number"
        >{{ node.number }}</span
      >
      {{ node.label }}
    </div>
  </ng-template>

  <ng-template let-node pTemplate="indicator">
    <div
      class="cursor-pointer flex align-items-center gap-2 relative"
      pTooltip="Rechtsklick für weitere Optionen."
      [showDelay]="600">
      <i *ngIf="node.locked" class="lock-overlay-icon fas fa-lock"></i>
      <a (click)="nodeSelect(node)">{{ node.label }}</a>
    </div>
  </ng-template>

  <ng-template pTemplate="empty">
    <app-alert header="Keine Indikatoren gefunden" [canToggle]="false">
      <p>
        <strong>WICHTIG:</strong> bevor Sie Indikatoren anlegen können, müssen
        Sie zuerst einen
        <a
          [routerLink]="[
            '/data-backend',
            {
              outlets: {
                overlay: [
                  'neu',
                  { outlets: { panel: ['indikatoren-bereich', 'neu'] } },
                ],
              },
            },
          ]"
          >Ordner</a
        >
        anlegen.
      </p>
      <p>
        Legen Sie Indikatoren über das
        <a
          [routerLink]="[
            '/data-backend',
            {
              outlets: {
                overlay: [
                  'neu',
                  { outlets: { panel: ['indikator', 'neu', 'general'] } },
                ],
              },
            },
          ]"
          >Formular</a
        >
        an, nutzen Sie den
        <a
          [routerLink]="['/data-backend', { outlets: { overlay: 'vorlagen' } }]"
          >Vorlagen-Pool</a
        >, oder importieren Sie Ihre Indikatoren im
        <a
          [routerLink]="[
            '/data-backend',
            {
              outlets: {
                overlay: ['cloud', { outlets: { panel: 'indikatoren' } }],
              },
            },
          ]"
          >Import und Export</a
        >
      </p>
    </app-alert>
  </ng-template>
</p-tree>

<p-contextMenu
  #cm
  appendTo="body"
  [model]="items"
  [styleClass]="'w-15rem'"></p-contextMenu>

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-10'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>

<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
